export default function WalletPage() {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Wallet</h1>
      <p className="text-gray-500">Wallet and transactions - coming soon</p>
    </div>
  )
}
